export {default} from './BottomTabNavigation.connect';
